import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import 'typeface-lato';
import './index.css';
import { Provider } from 'react-redux';
import App from './App';
import { CookiesProvider } from 'react-cookie';
import reportWebVitals from './reportWebVitals';
import WhatsappImage from '../src/assets/media/images/WhatsApp.svg';
import BellIcon from '../src/assets/media/images/bell-icon-font.png';
import { Dialog, Button, TextInput, Text } from '@mantine/core';
import { useDisclosure, useClickOutside } from '@mantine/hooks';
import { handicon } from '../src/api/imageUrl';
import store from './redux/store';
import axios from 'axios';
import { baseUrl } from './api/baseUrl';

const openWhatsApp = () => {
  const phone = '+923091258828';
  const message = 'Hello, I need assistance.';
  const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  window.open(url, '_blank');
};

function ChatDialog() {
  const [opened, { open, toggle, close }] = useDisclosure(false);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '' });
  const [errors, setErrors] = useState({ name: '', email: '', phone: '' });
  const [successMessage, setSuccessMessage] = useState(false);
  const dialogRef = useRef();
  useClickOutside(
    () => {
      if (opened) {
        close();
      }
    },
    null,
    [dialogRef.current]
  );

  useEffect(() => {
    if (window.location.pathname === '/') {
      open(); // Open chatbot only on the first page
    }
  }, []);

  const validateField = (name, value) => {
    let error = '';

    if (name === 'name') {
      error = value.length < 2 ? 'Name must have at least 2 letters' : '';
    } else if (name === 'email') {
      error = !/^\S+@\S+\.\S+$/.test(value) ? 'Invalid email format' : '';
    } else if (name === 'phone') {
      error = !/^\d{10,15}$/.test(value) ? 'Invalid phone number' : '';
    }

    setErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
  };

  const validateForm = () => {
    let newErrors = {
      name: formData.name.length < 2 ? 'Name must have at least 2 letters' : '',
      email: !/^\S+@\S+\.\S+$/.test(formData.email)
        ? 'Invalid email format'
        : '',
      phone: !/^\d{10,15}$/.test(formData.phone) ? 'Invalid phone number' : '',
    };

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === '');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    validateField(name, value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      // console.log('Form submitted successfully!', formData);
      setFormData({ name: '', email: '', phone: '' });
      axios
        .post(`${baseUrl}/subscribe`, {
          email: formData.email,
          name: formData.name,
          phone: formData.phone,
        })
        .then(function (response) {
          if (response.data == 1) {
            setSuccessMessage(true);
            setTimeout(() => {
              setSuccessMessage(false);
              close();
            }, 1000);
          }
          console.log(response.data);
        })
        .catch(function (error) {
          console.log('Error fetching data:', error);
          setErrors({ name: '', email: '', phone: '' });
          // setIsSearchLoading(false);
        });
    }
  };

  return (
    <>
      <div className="chat-bot-box">
        <button onClick={toggle}>
          <img src={BellIcon} alt="" />
          <span>Get live updates!</span>
        </button>
      </div>
      {/* {opened && ( */}
      {/* //  )} */}
      <div className="chat-bot-boxed">
        <Dialog
          opened={opened}
          className="main-chat-boxed"
          onClose={close}
          withCloseButton
          size="md"
          radius="md"
          ref={dialogRef}
        >
          <Text size="sm" mb="xs" fw={500} className="chat-box-get">
            Get live updates!
            <div dangerouslySetInnerHTML={{ __html: handicon }} />
          </Text>
          <div className="chat-field-boxed">
            <form onSubmit={handleSubmit}>
              <TextInput
                mb="xs"
                placeholder="Muhammad Ali Khan"
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                error={errors.name}
              />
              <TextInput
                mb="xs"
                placeholder="m.ali@gmail.com"
                label="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                error={errors.email}
              />
              <TextInput
                mb="xs"
                placeholder="033325564189"
                label="Mobile Number"
                type="number"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                error={errors.phone}
              />
              {successMessage ? (
                <p class="success-message">Your request has been submitted</p>
              ) : (
                ''
              )}
              <Button type="submit" mt="lg" fullWidth>
                Submit
              </Button>
            </form>
          </div>
        </Dialog>
      </div>
    </>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <CookiesProvider>
        <App />
        <ChatDialog />
        <div className="whatsapp-plugin" onClick={openWhatsApp}>
          <img src={WhatsappImage} alt="WhatsApp" />
        </div>
      </CookiesProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();